var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: -896,
    y: -256,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strike"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-ul"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hamburger-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-ol"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-task"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vertical-menu"
  }), /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sidebar-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pen1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hr"
  }), /*#__PURE__*/React.createElement("g", {
    id: "info"
  }), /*#__PURE__*/React.createElement("g", {
    id: "warning"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vue"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cog"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.513,13.926c10.574,0.15 19.249,9.657 23.594,17.837c0,0 -1.529,3.129 -2.963,5.132c-0.694,0.969 -1.424,1.913 -2.191,2.826c-0.547,0.65 -1.112,1.283 -1.698,1.898c-5.237,5.5 -12.758,9.603 -20.7,8.01c-8.823,-1.77 -16.02,-9.33 -20.346,-17.461c0,0 1.536,-3.132 2.978,-5.132c0.646,-0.897 1.324,-1.77 2.034,-2.617c0.544,-0.649 1.108,-1.282 1.691,-1.897c4.627,-4.876 10.564,-8.63 17.601,-8.596Zm-0.037,4c-5.89,-0.022 -10.788,3.267 -14.663,7.35c-0.527,0.555 -1.035,1.127 -1.527,1.713c-0.647,0.772 -1.265,1.569 -1.854,2.386c-0.589,0.816 -1.193,1.846 -1.672,2.721c3.814,6.409 9.539,12.198 16.582,13.611c6.563,1.317 12.688,-2.301 17.016,-6.846c0.529,-0.555 1.04,-1.128 1.534,-1.715c0.7,-0.833 1.366,-1.694 1.999,-2.579c0.586,-0.819 1.189,-1.851 1.667,-2.727c-3.958,-6.625 -10.73,-13.784 -19.082,-13.914Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowText);
export default __webpack_public_path__ + "static/media/show-text.70368515c17ee263e95c2ed2bce7b2d2.svg";
export { ForwardRef as ReactComponent };